import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastService } from 'src/app/core/toast.service';
import { FeedService } from '../../services/feed.service';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { log } from 'node:console';
import { DocumentViewerComponent } from 'src/app/modules/dashboard/modules/my-directory/pages/document-viewer/document-viewer.component';


@Component({
  selector: 'app-edit-comment-dialog',
  templateUrl: './edit-comment-dialog.component.html',
  styleUrls: ['./edit-comment-dialog.component.scss']
})
export class EditCommentDialogComponent {
  commentForm: FormGroup;
  commentStatus = false;

  commentCount: any;
  comments_attachments = [...this.data.comments_attachments];
  removedAttachments: any[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toast: ToastService,
    public feedService: FeedService,
    private mediaService: MediaService,
    private _dialog: MatDialog
  ) {
    this.commentForm = this.fb.group({
      comments: [data?.comment || '',
        [
          Validators.required,
          Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]') // Ensures non-whitespace + valid chars
        ]
      ]                    

    });
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file: File) => {
        const formData = new FormData();
      formData.append('directory', 'project');
      formData.append('file', file);
      this.mediaService.uploadMedia(formData).subscribe(response => {
        if (response && response.url) {
          this.comments_attachments.push({
            name: file.name,
            type: file.type,
            url: response.url,
          });
      }
      
      }, error => {
        console.error("Upload failed:", error);
      });
    });

    event.target.value = ''; 
  }



  ngOnInit(): void {
    this.updateCommentCount();

  }

  updateCommentCount() {
    this.commentCount = this.data.feed?.news_feeds_comments?.length || 0;

  }

  removeFile(index: number) {
    const removedFile = this.comments_attachments[index];

    this.comments_attachments.splice(index, 1);

    this.removedAttachments.push(removedFile);
  }

  getLikedUserData() {
    const feedId = this.data.feed?.id; // or ._id or whatever the correct property is
  
    if (feedId) {
      this.feedService.getNewsFeedIdData(feedId).subscribe(res => {
      });
    } else {
      console.error('Feed ID not found');
    }
  }
  


  async submitData() {
    if (this.commentForm.invalid) {
      this.toast.openSnackBar('Please enter valid details');
      this.commentForm.markAllAsTouched();
      return;
    }


    const updatedCommentText = this.commentForm.value.comments.trim();

    let payloaddata = {
      comments: updatedCommentText,
      comments_attachments: this.comments_attachments
    }
    
    

    try {
      const response = await this.feedService.updateNewsfeedComments(this.data.id, payloaddata);
      this.toast.openSnackBar('Comment updated successfully');
      this.dialogRef.close({ comments: updatedCommentText,
        comments_attachments: this.comments_attachments});
   
      this.getLikedUserData();

    } catch (error) {
      this.toast.openSnackBar('Failed to update comment');
      console.error("Error updating comment:", error);
    }
    
  }

  comments(id: any, comments: any) {
    throw new Error('Method not implemented.');
  }

  closeDialog() {
    this.dialogRef.close();
  }
  cancel(): void {
    this.dialogRef.close();
  }

    viewcommentDocuments(document, index: number,): void {
   
    this._dialog.open(DocumentViewerComponent, {
      width: '70%',
      panelClass: ['custom-modal'],
      data: {
        documents: document,
        initialIndex: index
      }
    });
  }

}